import * as R from 'ramda';

import type { MapFeature, MapInitialized, MapRendererApp } from './types.ts';

type FeatureWithId = MapFeature & {
  properties: MapFeature['properties'] & { customBadge?: string | null };
};

type AddCustomBadgesPayload = {
  ids: Array<string | number>;
  badge: string | null;
};

type HideMapBadgesPayload = {
  ids: Array<string | number>;
};

export default function BadgeController(app: MapRendererApp, mapInitialized: MapInitialized) {
  app.bus.on<AddCustomBadgesPayload>('map/addCustomBadges', async ({ ids, badge }) => {
    const idsSet = new Set(ids);
    const functor = (feature: FeatureWithId) => {
      if (feature.properties.id != null && idsSet.has(feature.properties.id)) {
        feature.properties.customBadge = badge;
      }
      return feature;
    };
    app.bus.send('map/mutateFeature', { functor });
  });

  app.bus.on<HideMapBadgesPayload>('map/hideMapBadges', ({ ids }) => {
    if (ids.length === 0) {
      return;
    }
    mapInitialized().then(map => {
      const allLayers = map.getStyle().layers;
      const poiLayerIds = R.pluck('id', allLayers).filter(
        s => s.includes('poi') && !s.includes('selected') && !s.includes('notSelected'),
      );
      const uniqIds = R.uniq(ids);
      poiLayerIds.forEach(layerId => {
        map.setPaintProperty(layerId, 'icon-opacity', [
          'case',
          ['match', ['get', 'id'], uniqIds, true, false],
          0,
          1,
        ] as unknown as number);
      });
    });
  });
}
